// Release the object URL a moment after the click so every browser has started the download.
const REVOKE_DELAY_MS = 1000;

// Downloads a blob with a temporary link.
export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};
